module.exports = __webpack_public_path__ + "img/woman-cut.86bf0901.png";